import { useTranslation } from "react-i18next";

import type { HaNPersonRelation } from "@lib/logic";

import { PersonRelationIcons } from "./PersonRelationIcons";

type PersonConnectionActionProps = {
  relation: HaNPersonRelation;

  isSending: boolean;

  onConnect: () => void;

  onAccept: () => void;
};

// How the user relates to the person: a check once connected, a clock while their request waits, else a plus that
// connects, or that accepts the person's request
export const PersonConnectionAction = ({ relation, isSending, onConnect, onAccept }: PersonConnectionActionProps) => {
  const { t } = useTranslation();

  switch (relation) {
    case "connected":
      return (
        <PersonRelationIcons
          icon="check"
          label={t("connection:Connected")}
        />
      );

    case "requestSent":
      return (
        <PersonRelationIcons
          icon="clock"
          label={t("connection:ConnectionRequestSent")}
        />
      );

    case "requestReceived":
      return (
        <PersonRelationIcons
          icon="plus"
          label={t("connection:AcceptConnection")}
          isBusy={isSending}
          onClick={onAccept}
        />
      );

    case "none":
      return (
        <PersonRelationIcons
          icon="plus"
          label={t("connection:Connect")}
          isBusy={isSending}
          onClick={onConnect}
        />
      );
  }
};
